import React, { useCallback, useEffect, useRef, useState } from "react";

type AutosizeTextareaProps = {
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  className?: string;
  disabled: boolean;
  rows: number;
};

const AutosizeTextarea: React.FC<AutosizeTextareaProps> = ({
  value,
  onChange,
  className,
  disabled,
  rows = 1,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const [textareaHeight, setTextareaHeight] = useState(0);

  const handleChange = useCallback((event: any) => {
    if (onChange) {
      onChange(event);
    }
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      setTextareaHeight(textareaRef.current.scrollHeight);
    }
  }, [value]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [textareaHeight]);

  return (
    <textarea
      ref={textareaRef}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      className={className}
      rows={rows}
    />
  );
};

export default AutosizeTextarea;
